/**
 * /matches/:matchId — standalone, deep-linkable detail page (PR-3 Task 22).
 *
 * Shares the MatchDetail container with the /matches split-pane right
 * pane; this page just adds breadcrumbs + back link and renders full-
 * width.
 *
 * Spec: docs/superpowers/specs/2026-05-28-admin-matches-summaries-design.md §7.2 / §7.3
 */
import { Link, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { MatchDetail } from './components/MatchDetail';

export default function MatchDetailPage() {
  const { matchId } = useParams<{ matchId: string }>();
  if (!matchId) {
    return (
      <div className="p-6 text-destructive">
        Missing match ID in URL.
      </div>
    );
  }

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: '0 auto' }}>
      <nav style={{ marginBottom: 12, fontSize: 13 }}>
        <Link
          to="/matches"
          className="inline-flex items-center gap-1 text-primary no-underline hover:underline"
        >
          <ChevronLeft size={14} /> Back to matches
        </Link>
        <span className="mx-1.5 text-muted-foreground">/</span>
        <span className="text-muted-foreground">
          <code>{matchId}</code>
        </span>
      </nav>
      <div className="rounded-lg border bg-card text-card-foreground">
        <MatchDetail key={matchId} matchId={matchId} />
      </div>
    </div>
  );
}
